import React from 'react'
import {Typography} from '@material-ui/core'

import {FusePageCarded} from '../../../../../@fuse'
import {requireAuthAndProject} from '../../../../../auth'
import ShippingContent from './ShippingContent'

const header = (
  <div className="flex items-center p-8 md:p-24">
    <img
      style={{
        width: '50px',
      }}
      className="text-32 mr-12"
      alt=""
      src="./assets/images/deeple/8_delivery-truck_white.png"
    />
    <Typography variant="title">Shipping</Typography>
  </div>
)

class ShippingPage extends React.Component {
  render() {
    return (
      <FusePageCarded
        header={header}
        content={<ShippingContent projectId={this.props.project.id} />}
        innerScroll
      />
    )
  }
}

export default requireAuthAndProject(ShippingPage)



// WEBPACK FOOTER //
// ./src/main/content/project/ecommerce/shipping/ShippingPage.js